var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex border border-red-500 min-w-0 overflow-x-auto"},[_vm._t("default"),_c('div',{staticClass:"flex-grow"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }